import api from '../config/axiosConfig';

export const DistritoService = {
  fetchDistritosPorProvincia: async (token, provinceId) => {
    try {
      const response = await api.get(`/locations/districts/${provinceId}`, {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      });

      if (response.data.success) {
        return response.data.data;
      } else {
        console.error("La API no devolvió success=true para distritos");
        return [];
      }
    } catch (error) {
      console.error("Error en DistritoService.fetchDistritosPorProvincia:", error);
      throw error;
    }
  },
};
